export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
// export const KEY = 'ba95e949-fe1e-4bd0-81ab-e650beae8a3b';
export const KEY ='7b6d1783-0e5e-44f9-a494-e2fb82a1bb70'
export const MODAL_CLOSE_SEC = 2.5;
